// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__1v2eO","imageUploader":"EGiftCard_imageUploader__3W9yI"};